import { render } from "./hoverAndStripped.vue?vue&type=template&id=b9f7fe88"
import script from "./hoverAndStripped.vue?vue&type=script&lang=js"
export * from "./hoverAndStripped.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__